var map = {
	"./br.json": [
		7863,
		3043
	],
	"./de.json": [
		532,
		3645
	],
	"./en.json": [
		1005,
		6551
	],
	"./es.json": [
		3458,
		2790
	],
	"./fr.json": [
		1822,
		1221
	],
	"./it.json": [
		5744,
		7453
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1531;
module.exports = webpackAsyncContext;